"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContent = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./ModalContent.scss");
var ModalContent = function (props) { return (react_1.default.createElement("div", { className: classnames_1.default('modal-card', props.className) },
    react_1.default.createElement("div", { className: "modal-card-head" },
        react_1.default.createElement("div", { className: "modal-card-title" }, props.title),
        react_1.default.createElement("button", { className: "delete", "aria-label": "close", onClick: props.onCloseClick })),
    react_1.default.createElement("div", { className: "modal-card-body" }, props.children),
    props.renderFooter &&
        react_1.default.createElement("div", { className: "modal-card-foot" }, props.renderFooter()))); };
exports.ModalContent = ModalContent;
